import { CommonProps, type PropsEditorProps } from "./common";

export function CheckboxProps(props: PropsEditorProps): JSX.Element {
  return <CommonProps {...props} />;
}
